import { getVisibleCards } from "../helpers";
import { isValueInCard } from "../search";
export default function (store, { value: rawValue, by, searchRule }) {
    const state = store.getState();
    const value = rawValue?.trim();
    const cardsMeta = state.cardsMeta;
    let search = { value: rawValue, by };
    if (!value) {
        Object.keys(cardsMeta).forEach(key => {
            const meta = cardsMeta[key];
            if (meta) {
                delete meta["dimmed"];
                delete meta["found"];
            }
        });
        search = null;
    }
    else {
        const cards = getVisibleCards(state);
        cards.map((card) => {
            const meta = (cardsMeta[card.id] = cardsMeta[card.id] || {});
            const rule = searchRule || isValueInCard;
            if (rule(card, value, by)) {
                meta.found = true;
                meta.dimmed = false;
            }
            else {
                meta.found = false;
                meta.dimmed = true;
            }
        });
    }
    store.setState({ cardsMeta, search });
}
//# sourceMappingURL=search.js.map